import { makeStyles } from '@mui/styles';

export const useProjectLogoStyles = makeStyles({
  wrapper: {
    width: '50px',
    '& img': {
      maxWidth: '100%'
    }
  }
});
